:host([light]) {
    & .welcome_st0 {
        fill: #ffffff;
    }
    & .welcome_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_1_);
    }
    & .welcome_st2 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000034804229626590809810000007501761233730985859_);
    }
    & .welcome_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000081642640730478114430000005391871120637536911_);
    }
    & .welcome_st4 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }
    & .welcome_st5 {
        fill: #1a4e85;
    }
    & .welcome_st6 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-miterlimit: 10;
    }
    & .welcome_st7 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000036955544064883338390000015748929145890682024_);
    }
    & .welcome_st8 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #bbdefb;
    }
    & .welcome_st9 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .welcome_st10 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000092454578546173386190000016581560625391089576_);
    }
    & .welcome_st11 {
        opacity: 0.3;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #858585;
        enable-background: new;
    }
    & .welcome_st12 {
        fill: #bbdefb;
    }
    & .welcome_st13 {
        opacity: 0.3;
        fill: #858585;
        enable-background: new;
    }
    & .welcome_st14 {
        fill: none;
    }
    & .welcome_st15 {
        fill: #ffffff;
        stroke: #1a4e85;
        stroke-miterlimit: 10;
    }
    & .welcome_st16 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #f5f5f5;
    }
    & .welcome_st17 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #1976d2;
    }
    & .welcome_st18 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #02c2ff;
    }
    & .welcome_st19 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #5ab552;
    }
    & .welcome_st20 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #1a4e85;
    }
}
:host([dark]) {
    & .welcome_st0 {
        fill: #ffffff;
    }
    & .welcome_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_1_);
    }
    & .welcome_st2 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000015325931113671118150000017506415190926326419_);
    }
    & .welcome_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000149360570365251602250000005596737416232006539_);
    }
    & .welcome_st4 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ced4db;
    }
    & .welcome_st5 {
        fill: #09264a;
    }
    & .welcome_st6 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 6;
        stroke-miterlimit: 10;
    }
    & .welcome_st7 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000136380731587674928170000013237057321856512420_);
    }
    & .welcome_st8 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #09264a;
    }
    & .welcome_st9 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 6;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .welcome_st10 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#welcome_SVGID_00000013891824051762336610000002480144365548368016_);
    }
    & .welcome_st11 {
        opacity: 0.3;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #858585;
        enable-background: new;
    }
    & .welcome_st12 {
        fill: #ced4db;
    }
    & .welcome_st13 {
        opacity: 0.3;
        fill: #858585;
        enable-background: new;
    }
    & .welcome_st14 {
        fill: none;
    }
    & .welcome_st15 {
        fill: #ced4db;
        stroke: #09264a;
        stroke-miterlimit: 10;
    }
    & .welcome_st16 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #bec6cc;
    }
    & .welcome_st17 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #1976d2;
    }
    & .welcome_st18 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #02c2ff;
    }
    & .welcome_st19 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #5ab552;
    }
}
